import clsx from 'clsx';

import { MapUser } from '@atom/types/map';

import classes from './drawerContent.module.css';

interface Props {
  user: MapUser;
}

const UserListItem = ({ user }: Props) => {
  const { photoUrl, firstName, lastName, role, email } = user;

  return (
    <div className={classes.listItemV2}>
      <div className={classes.iconContainer}>
        <img
          src={photoUrl}
          onError={event => {
            // @ts-ignore
            event.target.onerror = null;
            // @ts-ignore
            event.target.src =
              'https://lh3.googleusercontent.com/a/default-user=s140-p-k-rw-no';
          }}
        />
      </div>
      <div className={classes.descriptionContainer}>
        <div className={classes.heading}>
          {firstName} {lastName}
        </div>
        <div className={clsx(classes.secondary, classes.tall)}>{email}</div>
        <div className={clsx(classes.secondary, classes.tall)}>{role}</div>
      </div>
    </div>
  );
};

export default UserListItem;
